import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import Text from '@dbk/ui-text';
import ScrollableLayout from '../../../components/common/scrollable-layout';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import { downloadPdf } from '../../../muster/utils/downloader';
import config from '../../../data/settings.json';
import uiJson from '../../../data/ui.json';
import { PDF_NAME } from '../../../../src/constants';

class TermsConditionLUX extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentContent: undefined
    }
  }
  componentWillMount() {
    this.props.loginTerms.onGetPdf();
  }

  onDownload = (item) => {
    this.setState({
      currentContent: item.key
    })

  }

  renderData = () => {
    const { i18n: { messages }, loginTerms: { pdfLinkData }, modalContentType ,auth : { langCode } } = this.props;
    const { currentContent } = this.state;

    const remoteUrl = window.location.href.split('ebanking')[0] + config.environments.relative.remoteUrl;
    let termsLink = remoteUrl + pdfLinkData.tcPdfLink;
    let fileName = ""

    if (currentContent === 'EN' && modalContentType === "TnC For LUX") {
      if (langCode === 'de' ){
        termsLink = pdfLinkData.tcPdfLink && remoteUrl + pdfLinkData.tcPdfLink.replace("SwissGerman", "English");
      }
      else {
        termsLink = remoteUrl + pdfLinkData.tcPdfLink;
      }
      fileName = PDF_NAME.ONLINE_TERMS_ENGLISH
    }
    if (currentContent === 'DE' && modalContentType === "TnC For LUX") {
      termsLink = pdfLinkData.tcPdfLink && remoteUrl + pdfLinkData.tcPdfLink.replace("English", "SwissGerman");
      fileName = PDF_NAME.ONLINE_TERMS_GERMAN
    }

    if (termsLink && fileName) { downloadPdf(termsLink, fileName, 'application/pdf'); }

  }

  render() {
    const { i18n: { messages }, loginTerms: { pdfLinkData }, modalContentType } = this.props;
    const { currentContent } = this.state;

    if (currentContent) {
      this.renderData();
    }

    const items = [{
      "key": "EN", 
      "lang": "English",
    },
    {
      "key": "DE", 
      "lang": "German", 
    }]

    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="padding-left-20 row consolidation">
            <div className="cloumns small-12 large-12 profile-container">
              <div className="profile__content">
                <div className="term-condition">
                  <NavigationList>
                    {
                      items && items.map((item) => (
                        <NavigationListItem
                          hasArrow key={item.key} onClick={() => this.onDownload(item)}>

                          <Text>{item.lang}</Text>

                        </NavigationListItem>
                      ))
                    }
                  </NavigationList>
                </div>
              </div>
            </div>
          </div>

        }
      />
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    loginTerms: {
      pdfLinkData: true,
      onGetPdf: { $call: 'getPdfLink' }
    },
    auth : {
       langCode : true,
    },
  }
})(TermsConditionLUX);